<script src="./QuoteConfirmation.js"></script>
<i18n src="./QuoteConfirmation.txt" lang="yaml"></i18n>


<template>
  <div v-if="true" class="pt-80 pb-100">
    <div class="container">
      <div class="order-complete text-center">
        <h2>{{t('thankYou')}}</h2>
        <h4>Quote with an ID <strong>{{ id }}</strong> has been created.</h4>
        <router-link class="mt-50" to="/">
          {{t('continueShopping')}}
        </router-link>
        <router-link class="mt-50 ml-5" :to="'/user/quote/'+id">
          {{t('viewQuote')}}
        </router-link>
      </div>
    </div>
  </div>
  <h1 v-else>...</h1>
</template>
